import { HereResult } from '@user/store/services/hereGeoCoder'
import { useCallback, useEffect, useState } from 'react'
import { logger } from '@user/utils/logger'

const STORAGE_KEY = 'recentSearches'

export function useRecentLocations() {
  const [recentSearches, setRecentSearches] = useState<HereResult[]>([])

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY)
      if (!raw) return
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed)) setRecentSearches(parsed.filter(Boolean))
    } catch {
      // ignore malformed storage
    }
  }, [])

  const addRecentSearch = useCallback((item: HereResult) => {
    setRecentSearches((prevSearches) => {
      // Filter out the item if it already exists to prevent duplicates
      const filteredSearches = prevSearches.filter(
        (search) => search.id !== item.id,
      )
      // Add the new item to the beginning and keep the last 5 unique searches
      const updatedSearches = [item, ...filteredSearches].slice(0, 5)
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedSearches))
      return updatedSearches
    })
    logger.log('Added recent search', item)
  }, [])

  const clearRecentSearches = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY)
    setRecentSearches([])
  }, [])

  return { recentSearches, addRecentSearch, clearRecentSearches }
}
